module.exports = __webpack_public_path__ + "static/media/CTLI_14-315w.1fb6cd09.webp";